<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      height="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>宣传专区</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="24" class="row-bg">
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="标题:" prop="title">
                          <el-input
                            id="title"
                            v-model="SelectData.title"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="宣传分类:" prop="categoryId">
                          <el-select
                            v-model="SelectData.categoryId"
                            placeholder="宣传分类"
                            :disabled="IsReadonly"
                          >
                            <el-option
                              v-for="item in Categorys"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="开始时间:" prop="startTime">
                          <el-date-picker
                            v-model="SelectData.startTime"
                            type="datetime"
                            :readonly="IsReadonly"
                          ></el-date-picker>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="结束时间:" prop="endTime">
                          <el-date-picker
                            v-model="SelectData.endTime"
                            type="datetime"
                            :readonly="IsReadonly"
                          ></el-date-picker>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="24" class="row-bg">
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="类型:" prop="type">
                          <el-select
                            v-model="SelectData.type"
                            placeholder="类型"
                            :disabled="IsReadonly"
                          >
                            <el-option
                              v-for="item in types"
                              :key="item.id"
                              :label="item.txt"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12" v-if="SelectData.type==0">
                      <div class="grid-content bg-purple">
                        <el-form-item label="url:" prop="url">
                          <el-input
                            id="url"
                            v-model="SelectData.url"
                            clearable
                            :readonly="IsReadonly"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12" v-if="SelectData.type==2">
                      <div class="grid-content bg-purple">
                        <el-form-item label="视频文件:" prop="fileName">
                          {{SelectData.fileName}}
                          <el-button v-if="!IsReadonly" @click="imageClick('2',SelectData)">选择文件</el-button>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <el-form-item label="封面图片:" prop="imgUrl">
                            <img
                              :src="headIMG(SelectData.imgUrl)"
                              @click="imageClick('1',SelectData)"
                              title="点我选择章节封面"
                              style="width: 120px;height:120px;cursor:pointer" >
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="24" class="row-bg">
                    <el-col :span="24" v-if="SelectData.type==1 || SelectData.type==2">
                      <div class="grid-content bg-purple">
                        <el-form-item label="文本内容:" prop="text">
                          <MyCkdeitor
                            @sendContnet="getContent"
                            :content="SelectData.text"
                          ></MyCkdeitor>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
  <SubResourceCenter
  ref="SubResourceCenter"
  v-model:ResourceCenterDialogVisible="ResourceCenterDialogVisible"
  @close-dialog="ResourceCenterCloseDialog"
  @handle-cancel="ResourceCenterHandleCancel"
  @handle-confirm="ResourceCenterHandleConfirm"
></SubResourceCenter>
</template>

<script>
import {
  GetDataById,
  ModifyNews,
  AddNews,
} from "@api/News/ApiNews";

import {GetDataNewsCategoryList} from "@api/News/ApiNewsCategory"
import SubResourceCenter from "@views/YZResource/SubResourceCenter.vue";
import { ossPreview } from "@/util/ossClient.js"
import MyCkdeitor from "../RichText/MyCkdeitor.vue";

export default {
  name: "NewsEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ResourceCenterDialogVisible:false,
      SelectData: {
        type : 0,
        text : ''
      },
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
      types:[{id:0,txt:'url链接'},{id:1,txt:'富文本'},{id:2,txt:'视频'}],
      Categorys:[],
    };
  },
  components: {
    SubResourceCenter,
    MyCkdeitor,
  },
  computed: {

  },
  created() {
  },
  mounted() {},
  methods: {
    //获取富文本编译器内容
    getContent(val) {
      this.SelectData.text = val;
    },
    //图片路径设定
    headIMG(img) {

      const imgData = require('../../assets/images/logo.png')
      if(img) {
        if(img.indexOf("https://")>-1)return img
        return ossPreview(img, "1")
      } else {
        return imgData;
      }
    },
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type) {

      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;

      _this.getDataNewsCategoryList();

      _this.SelectData = {
        type : 1 ,
        text : ''
      };

      if (type == "Add") {
        _this.IsReadonlyCode = false;
        return;
      } else if (type == "Detail") {
        _this.IsReadonly = true;
        _this.IsShowConfirm = false;
      }
      GetDataById(id).then(function (data) {
        _this.SelectData = data;
      });
    },
    getDataNewsCategoryList(){
      let _this = this
      GetDataNewsCategoryList({
        queryModel: {},
        pageindex: 1,
        PageSize: 10000,
      }).then(res=>{
        _this.Categorys = res.entities
      }).catch(res=>{
        this.$message.error(res.message)
      })
    },
    //打开资源弹框入口
    imageClick:function(type,row){
      if(this.IsReadonly)return
      // { GroupTypeCode: "1", GroupTypeName: "图片" },
      // { GroupTypeCode: "2", GroupTypeName: "视频" },
      // { GroupTypeCode: "3", GroupTypeName: "文档" },
      this.ResourceCenterDialogVisible=true
      var obj={
        type:[type],//展示的页签
        selectFileType:"1",//选中的文件的类型 1图片，2视频，3文档
        selectId:0,//选中的文件的id
        isSingle:true,//是否单选
        source:"CourseEdit",//数据来源页面
        row:row,//行
        sourceItem:{},//资源文件对象
      };
      if(type=='1'){
        obj.selectFileType = "1"
        obj.selectId = row.imageId
        obj.type=['1']
      }
      else if(type=='2')
      {
        obj.selectFileType = "2";//row.fileType == undefined ? '2' : row.fileType
        obj.selectId=row.resourcesId
        obj.type=['2']
      }
      this.$refs.SubResourceCenter.loading(obj);
    },
    ResourceCenterCloseDialog() {
      this.ResourceCenterDialogVisible = false;
    },
    ResourceCenterHandleCancel() {
      this.ResourceCenterDialogVisible = false;
    },
    //选择资源文件之后 点击确认的回调事件
    ResourceCenterHandleConfirm(obj) {
      this.ResourceCenterDialogVisible=false
      if(obj.selectFileType==1){
        obj.row.imageId=obj.sourceItem[0].PicLogicalCode
        obj.row.imgName=obj.sourceItem[0].FileName
        obj.row.imgUrl=obj.sourceItem[0].ImgSrc
      } else if(obj.selectFileType==2)
      {
        obj.row.resourcesId=obj.sourceItem[0].PicLogicalCode
        obj.row.fileName=obj.sourceItem[0].FileName
        obj.row.fileUrl=obj.sourceItem[0].ImgSrc
      }
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      var _this = this;
      if (!_this.validate()) return;
      if (_this.OpStatus == "Add") {
        AddNews(this.SelectData).then(function (data) {
          _this.$message.success("新增成功!");
          _this.$emit("handle-confirm");
        });
      } else if (_this.OpStatus == "Modify") {
        ModifyNews(this.SelectData).then(function (data) {
          _this.$message.success("编辑成功!");
          _this.$emit("handle-confirm");
        });
      }
    },
    validate() {
      if (!this.SelectData.title || this.SelectData.title == "") {
        this.$message.error("标题是必须的!");
        return false;
      }
      if (!this.SelectData.categoryId || this.SelectData.categoryId == "") {
        this.$message.error("宣传分类是必须的!");
        return false;
      }
      if (!this.SelectData.startTime || this.SelectData.startTime == "") {
        this.$message.error("开始时间是必须的!");
        return false;
      }
      if (!this.SelectData.endTime || this.SelectData.endTime == "") {
        this.$message.error("结束时间是必须的!");
        return false;
      }

      if(this.SelectData.type == 0)
      {
        if (!this.SelectData.url || this.SelectData.url == "") {
          this.$message.error("url链接是必须的!");
          return false;
        }
      }
      else if(this.SelectData.type == 1)
      {
        if (!this.SelectData.text || this.SelectData.text == "") {
          this.$message.error("文本内容是必须的!");
          return false;
        }
      } else if(this.SelectData.type == 2)
      {
        if (!this.SelectData.resourcesId || this.SelectData.resourcesId == "") {
          this.$message.error("视频文件是必须的!");
          return false;
        }
      }
      if (!this.SelectData.imageId || this.SelectData.imageId == "") {
        this.$message.error("封面图片是必须的!");
        return false;
      }
      return true;
    },
    choosevideo(){
      debugger;
    },
  },
};
</script>

<style lang="scss" scoped >
.select-items {
  position: relative;
  display: flex;
}

.select-item {
  height: 50px;
  flex: 33.33%;
  display: flex;
  margin: 0 10px;
}
.item-lab {
  flex: 25%;
  line-height: 50px;
  display: flex;
  position: relative;
}

.item-input {
  flex: 75%;
}

.item-lab > label {
  align-items: flex-end;
  position: absolute;
  right: 5px;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}

::v-deep .el-form-item--small .el-form-item__label {
  width: 100px;
  text-align: left;
  padding: 0;
}

::v-deep .el-date-editor--datetime {
  width: 100%;
}
.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}
.el-textarea {
  margin: 5px 0;
  width: 100%;
}
::v-deep .el-select {
  width: 100% !important;
  min-width: 20px;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
</style>
